export default __webpack_public_path__ + "static/media/E_Contract.70354ee7.jpg";